<template>
  <div class="login">
    <div class="sidebar">
      <div class="flex">
        <img class="h-20 mr-4" src="~@/assets/img/logo.svg" />
        <div class="brand">
          <div class="title">PandaVue</div>
          <div class="subtitle">WWF-Australia</div>
        </div>
      </div>
      <form @submit.prevent="forgotPassword">
        <Alert :message="message"></Alert>
        <div class="field" v-if="!success">
          <label>Email</label>
          <input required v-model="email" type="email" name="email" data-cy="email" />
        </div>
        <button
          class="primary"
          type="submit"
          :class="[loading === 1 ? 'load' : loading === 2 ? 'ok' : null]"
          v-if="!success"
        >
          Reset Password
        </button>
        <div class="link" v-on:click="navigateTo('/login')">Back to Login →</div>
      </form>
      <div class="footer"></div>
    </div>
    <div class="image bg-local" :style="{ 'background-image': 'url(\'' + image + '\')' }"></div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import Alert from '../components/Alert.vue';

export default {
  name: 'ForgotPassword',
  components: {
    Alert,
  },
  data() {
    return {
      image: require(`@/assets/img/background.jpg`),
      email: '',
      loading: 0,
      message: null,
      success: false,
    };
  },
  methods: {
    forgotPassword: function () {
      this.loading = 1;
      this.message = null;
      const email = this.email;

      if (!this.email.match(/^\S+@\S+\.\S+$/)) {
        this.message = {
          content: 'Please enter a valid email address',
          type: 'error',
        };
      } else {
        firebase
          .auth()
          .sendPasswordResetEmail(email)
          .then()
          .catch(() => {})
          .finally(() => {
            this.success = true;
            this.loading = 0;
            this.message = {
              content: 'An email has been sent, follow the instructions to reset your password. ',
              type: 'success',
            };
          });
      }
    },
    navigateTo: function (url) {
      if (this.$route.path !== url) {
        this.$router.push({ path: url });
      }
    },
  },
};
</script>

<style scoped>
.login {
  @apply flex h-screen w-full;
}

.sidebar {
  @apply flex flex-col justify-between items-start w-96 p-6 bg-gray-50;
}

button {
  @apply mt-4;
}

.link {
  @apply text-gray-600 cursor-pointer;
}

.image {
  @apply hidden md:flex-1 md:flex items-center justify-center bg-white bg-cover;
}

.brand {
  @apply flex flex-col justify-center;
}

.brand .title {
  @apply text-xl font-bold;
}

.brand .subtitle {
  @apply text-xs;
}
</style>
